<template>
  <base-material-card color="primary" icon="mdi-pencil" inline class="px-5 py-3">
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">Informações Básicas</div>
    </template>
    <v-form class="pt-5">
      <v-row align="center" no-gutters class="ml-0">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required" name="Nome do relatório">
            <v-text-field v-model="nome" label="Nome do Relatório" outlined :error-messages="errors" class="ml-4" />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="ml-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required" name="Base de dados">
            <v-select
              v-model="view"
              no-gutters
              outlined
              :items="bases"
              item-value="nome"
              item-text="descricao"
              label="Base de Dados"
              :error-messages="errors"
              :loading="loading"
              :disabled="loading"
              @change="baseDeDadosChange"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  export default {
    props: {
      consulta: {
        type: Object,
        default: () => {}
      }
    },

    emits: ['baseDeDadosChange'],

    data: () => ({
      nome: '',
      view: '',
      loading: false
    }),

    computed: {
      bases() {
        return this.$store.state.app.modulosPerfisLiberados.tabelas_liberadas;
      }
    },

    methods: {
      exportCampos() {
        return {
          nome: this.nome,
          view: this.view
        };
      },

      baseDeDadosChange() {
        this.$emit('baseDeDadosChange', this.view);
      }
    },

    watch: {
      consulta(newValue) {
        this.nome = newValue.nome;
        this.view = JSON.parse(newValue.estrutura_json).tabela;
        this.baseDeDadosChange();
      }
    }
  };
</script>